// systemRoles.js
// 3 role hệ thống mặc định – hard-code tại client, không lưu DB.
// id dùng tiền tố '@' để phân biệt với UUID từ server.

export const SYSTEM_ROLE_IDS = {
    OWNER: '@owner',
    ADMIN: '@admin',
    MEMBER: '@member',
}

export const getSystemRoles = (t) => [
    {
        id: SYSTEM_ROLE_IDS.OWNER,
        _type: 'entity_role',
        name: t('owner'),
        is_system: true,
        active: true,
        permissions: null, // full – hiển thị "Tất cả quyền" ở UI
        role_description: 'owner_role_description',
    },
    {
        id: SYSTEM_ROLE_IDS.ADMIN,
        _type: 'entity_role',
        name: t('admin'),
        is_system: true,
        active: true,
        permissions: null, // full trừ set_permissions – xử lý ở UI
        role_description: 'admin_role_description',
    },
    {
        id: SYSTEM_ROLE_IDS.MEMBER,
        _type: 'entity_role',
        name: t('member'),
        is_system: true,
        active: true,
        permissions: {}, // không có quyền gì
        role_description: 'member_role_description',
    },
]